var alignment_rtlignore_default = {
  "alignLeft": "bIJoA",
  "textWrapNowrap": "D2qkb",
  "alignRight": "LcAKX",
  "alignCenter": "MUNFC",
  "sizeFullWidth": "dy9nF",
  "renderedInTable": "IcjS7",
  "sizeOriginal": "rvOAo",
  "sizeContent": "Sdu1j",
  "sizeSmall": "YZbvE",
  "sizeSmallCenter": "uzN9w",
  "flex": "Pic42",
  "LEFT": "gCVUw",
  "CENTER": "uMY-a",
  "RIGHT": "EVj-H",
  "AUTO": "c1YlN",
  "JUSTIFY": "_3L54w"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
